/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthAmplifyService } from "src/app/shared/service/auth-amplify.service";
import { AlertModalService } from "src/app/modules/locations/services/modal/alert-modal.service";
import { Auth } from "aws-amplify";

@Component({
  selector: "app-authorize",
  templateUrl: "./authorize.component.html",
  styleUrls: ["./authorize.component.scss"],
})
export class AuthorizeComponent {
  tokenDetails: any;
  token: any;
  previousUrl: any;
  subscribeFormData: any;
  errortriggered: boolean = false;
  isCancelVisible: boolean = false;
  auth:any=Auth
  proxyAuth:string = environment.proxyUrl
  code: any;
  constructor(
    private readonly router: Router,
    private readonly authAmplifyService: AuthAmplifyService,
    private readonly alertModalService: AlertModalService,
    private readonly route: ActivatedRoute
  ) {
    
    this.route.queryParams.subscribe(params => {
      this.code = params['code'];
      if (this.code) {
        authAmplifyService.callback(this.code).subscribe(() => {
          this.router.navigate(["/events"]);
        });
      }
    });
  }


  
  async removeIndexedDb(){
    const dbs = await window.indexedDB.databases()
    dbs.forEach((db:any) => { window.indexedDB.deleteDatabase(db.name) })
  }

  clearData() {
    window.localStorage.clear();
    window.sessionStorage.clear();
    this.clearAllCookies();
  }

  clearAllCookies() {
    const cookies = document.cookie.split(";");

    for (const element of cookies) {
      const cookie = element;
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
  }

  getRoleGroup(jwt: string) {
    try {
      return JSON.parse(atob(jwt.split(".")[1]));
    } catch (_e) {
      return null;
    }
  }
}
